let navigationConfig = [
  {
    id: 'modules',
    title: '',
    translate: '',
    type: 'group',
    icon: 'apps',
    children: [
      {
        id: 'dashboard',
        title: 'DASHBOARD',
        translate: 'DASHBOARD',
        type: 'collapse',
        url: '/dashboard',
        children: [
          {
            id: 'requests',
            title: 'REQUEST BOARD',
            translate: 'REQUEST_BOARD',
            type: 'item',
            url: `/requests`,
          },
        ],
      },
      {
        id: 'jobs',
        title: 'JOBS',
        translate: 'JOBS',
        type: 'collapse',
        url: '/jobs',
        children: [
          {
            id: 'jobs_drafts',
            title: 'JOB DRAFTS',
            translate: 'JOB_DRAFTS',
            type: 'item',
            url: `/jobs-drafts`,
          },
        ],
      },
      {
        id: 'customers',
        title: 'CUSTOMERS',
        translate: 'CUSTOMERS',
        type: 'collapse',
        url: '/customers',
        children: [
          {
            id: 'uninvoiced',
            title: 'UNINVOICED TICKETS',
            translate: 'UNINVOICED_TICKETS',
            type: 'item',
            url: '/uninvoiced',
          },
        ],
      },
    ],
  },
  {
    id: 'Truck',
    title: 'TRUCK',
    translate: 'TRUCK',
    type: 'collapse',
    url: '/truck',
    children: [
      {
        id: 'mileage_log',
        title: 'FUEL LOG',
        translate: 'FUEL_LOG',
        type: 'item',
        url: '/mileages',
      },
      {
        id: 'Traffic_Stops',
        title: 'TRAFFIC STOPS',
        translate: 'TRAFFIC_STOPS',
        type: 'item',
        url: '/dps',
      },
      {
        id: 'addinspections',
        title: 'INSPECTIONS',
        translate: 'INSPECTIONS',
        type: 'item',
        url: '/inspections',
      },
    ],
  },
  {
    id: 'driverlist',
    title: 'DRIVER LIST',
    type: 'collapse',
    translate: 'DRIVER_LIST',
    url: `/drivers`,
    children: [
      {
        id: 'timesheet',
        title: 'TIME SHEETS',
        translate: 'TIME_SHEETS',
        type: 'item',
        url: '/timesheet',
      },
    ],
  },
  {
    id: 'dispatch',
    title: 'DISPATCH',
    translate: 'DISPATCH',
    type: 'collapse',
    url: '/dispatch',
    children: [
      {
        id: 'dispatch_template',
        title: 'DISPATCH ASSETS',
        translate: 'DISPATCH_ASSETS',
        type: 'item',
        url: `/dispatch/template`,
      },
    ],
  },
  {
    id: 'stafflist',
    title: 'USER LIST',
    translate: 'USER_LIST',
    type: 'item',
    url: `/users`,
  },

  {
    id: 'subcontractors-new',
    title: 'SUBCONTRACTORS',
    type: 'item',
    translate: 'SUBCONTRACTORS',
    url: '/sub-contractor',
    tooltip:
      'Subcontractors are independent truck owners who operate under their own authority. They maintain ownership of their trucks and are responsible for their own subscriptions. As a result, subcontractors do not contribute towards your subscription count',
  },

  {
    id: 'owner-operators',
    title: 'OWNER OPERATORS',
    translate: 'OWNER_OPERATORS',
    type: 'item',
    url: '/ownerops',
    tooltip:
      'Owner Operators are independent truck owners without their own Loadz subscription. They count as a subscription seat per driver.',
  },
  {
    id: 'company-list',
    title: 'COMPANY LIST',
    translate: 'COMPANY_LIST',
    type: 'item',
    url: '/companies',
  },

  // Visible para super-admin y power dispatcher
  {
    id: 'fuel-inventory',
    title: 'FUEL DASHBOARD',
    translate: 'FUEL/LUBE_DASHBOARD',
    type: 'collapse',
    url: '/fuel-inventory',
    auth: ['super-admin', 'power dispatcher', 'company'],
    children: [
      {
        id: 'fuel-inventory-inventory',
        title: 'FUEL/LUBE INVENTORY',
        translate: 'FUEL/LUBE_INVENTORY',
        type: 'item',
        url: '/fuel-inventory/inventory',
      },
      {
        id: 'fuel-inventory-transactions',
        title: 'FUEL/LUBE TRANSACTIONS',
        translate: 'FUEL/LUBE_TRANSACTIONS',
        type: 'item',
        url: '/fuel-inventory/transactions',
      },
    ],
  },
  {
    id: 'subscriptions-management',
    title: 'SUBSCRIPTION',
    translate: 'SUBSCRIPTION',
    type: 'collapse',
    url: '/subscriptions-management',
    children: [
      {
        id: 'subscriptions-companies',
        title: 'SUBSCRIPTION COMPANIES',
        translate: 'SUBSCRIPTION_COMPANIES',
        type: 'item',
        url: '/subscriptions-companies',
      },
      {
        id: 'subscriptions-invoices',
        title: 'SUBSCRIPTION INVOICES',
        translate: 'SUBSCRIPTION_INVOICES',
        type: 'item',
        url: '/subscriptions-invoices',
      },
    ],
  },
  {
    id: 'agent',
    title: 'SALES AGENT',
    translate: 'SALES_AGENT',
    type: 'item',
    url: '/agent',
  },
  // {
  //   id: 'datamapper',
  //   title: 'DATAMAPPER',
  //   translate: 'DATAMAPPER',
  //   type: 'collapse',
  //   url: '/datamapper',
  //   children: [
  //     {
  //       id: 'datamapper-instructions',
  //       title: 'Instrucciones',
  //       type: 'item',
  //       url: '/datamapper/instructions',
  //     },
  //     {
  //       id: 'datamapper-groups',
  //       title: 'Grupos',
  //       type: 'item',
  //       url: '/datamapper/groups',
  //     },
  //     {
  //       id: 'datamapper-integrations',
  //       title: 'Integraciones',
  //       type: 'item',
  //       url: '/datamapper/integrations',
  //     },
  //   ],
  // },
];
/* {
      id: 'salary',
      title: 'EARNINGS',
      translate: '',
      type: 'item',
      // icon: 'money',
      url: '/salary'
    }, */

export default navigationConfig;
